import React from 'react'
import { Grid } from '@mui/material'

// Common Components
import EventUpdateModal from './EventUpdateModal'
import EventArchiveModal from './EventArchiveModal'
import EventViewModal from './EventViewModal'

interface EventActionsProps {
  id: string
  completed: boolean
}

const EventActions: React.FC<EventActionsProps> = ({ id, completed }) => {
  return (
    <Grid container spacing={{ md: 0.5, lg: 1 }} justifyContent='center' alignItems='center'>
      <Grid>
        <EventViewModal id={id} />
      </Grid>
      <Grid>
        <EventUpdateModal id={id} completed={completed} />
      </Grid>
      <Grid>
        <EventArchiveModal id={id} />
      </Grid>
    </Grid>
  )
}

export default EventActions
